import { reactive } from "vue";
import moment from 'moment';
const CryptoJS = require("crypto-js");
const ENCRYPT_KEY =
  "000102030405060708090a0b0c0d0e0f101112131415161718191a1b1c1d1e1f";
const ENCRYPT_IV = "101112131415161718191a1b1c1d1e1f";
export default function commonFunctions() {
  const timerState = reactive({
    timerMobileStatus: false,
    timerMobileCount: 120,
    timerMobileInterval: 0,
    resendOtpBtnStatus: false,
  });

  // const onlyNumber = ($event) => {
  //   let keyCode = $event.keyCode ? $event.keyCode : $event.which;
  //   if (keyCode < 48 || keyCode > 57) {
  //     $event.preventDefault();
  //   }
  // };

  const onlyNumbers = ($event) => {
    const key = $event.key;
    if (!/^\d$/.test(key)) {
      $event.preventDefault();
    }
  };


  const onlyNumber = ($event) => {
    const keyCode = $event.keyCode || $event.which;
    // Block Shift key (used for %, !, @ etc.)
    if ($event.shiftKey) {
      $event.preventDefault();
      return;
    }
  
    // Allow: 0–9 (main keyboard) and 0–9 (numpad)
    if (
      (keyCode >= 48 && keyCode <= 57) || 
      (keyCode >= 96 && keyCode <= 105) || 
      [8, 9, 37, 39, 46].includes(keyCode)
    ) {
      return;
    }
  
    $event.preventDefault();
  };

  const isLetterWithSpace = (e) => {
    let value = e.target.value;
    let count = countWhiteSpace(e.target.value);
    if (count <= 2) {
      let charspace = String.fromCharCode(e.keyCode);
      if (charspace == " " && (value == null || value == "")) {
        e.preventDefault();
      } else if (/^[A-Za-z\s]+$/gm.test(charspace)) {
        return true;
      } else {
        e.preventDefault();
      }
    } else {
      e.preventDefault();
    }
  };

  function countWhiteSpace(str) {
    let gaps = 0;
    const isWhitespace = (ch) => " \t\n\r\v".indexOf(ch) > -1;
    for (let i = 0; i < str.length; i++)
      if (isWhitespace(str[i]) && !isWhitespace(str[i - 1])) ++gaps;
    return gaps;
  }

  const isLetterWithOutSpace = (e) => {
    let char = String.fromCharCode(e.keyCode);
    if (/^[A-Za-z]+$/.test(char)) return true;
    else e.preventDefault();
  };

  const isAlphaNumeric = (e) => {
    let char = String.fromCharCode(e.keyCode);
    if (/^[A-Za-z0-9]+$/.test(char)) return true;
    else e.preventDefault();
  };

  const onlyNumberMobile = (e) => {
    // Logic for only allowing numbers
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const onPasteMobile = (e) => {
    // Handle paste event
    const pasteData = e.clipboardData.getData("Text");
    if (!/^\d{10}$/.test(pasteData)) {
      e.preventDefault();
    }
  };
  const onPasteJobMobile = (e) => {
    const pasteData = e.clipboardData.getData("Text");
    
    // Allow only digits and up to 12 digits
    if (!/^\d{1,12}$/.test(pasteData)) {
      e.preventDefault();
    }
  };

  const onPasteAadhar = (e) => {
    // Handle paste event
    const pasteData = e.clipboardData.getData("Text");
    if (!/^\d{12}$/.test(pasteData)) {
      e.preventDefault();
    }
  };

  // const onlyNumberMobile = ($event) => {
  //   let keyCode = $event.keyCode ? $event.keyCode : $event.which;
  //   if (keyCode < 48 || keyCode > 57) {
  //     $event.preventDefault();
  //   }

  //   var mobileInput = document.getElementById("formUsernameInput");
  //   if (
  //     (mobileInput.value == "" || mobileInput.length > 1) &&
  //     (keyCode == 48 ||
  //       keyCode == 49 ||
  //       keyCode == 50 ||
  //       keyCode == 51 ||
  //       keyCode == 52)
  //   ) {
  //     $event.preventDefault();
  //   }
  // };

  const mobileSearchFormat = ($event) => {
    let keyCode = $event.keyCode ? $event.keyCode : $event.which;
    if (keyCode < 48 || keyCode > 57) {
      $event.preventDefault();
    }
    var mobileInput = document.getElementById("searchmobInput");
    if (
      (mobileInput.value == "" || mobileInput.length > 1) &&
      (keyCode == 48 ||
        keyCode == 49 ||
        keyCode == 50 ||
        keyCode == 51 ||
        keyCode == 52)
    ) {
      $event.preventDefault();
    }
  };

  const onlymobileEditFormat = ($event) => {
    let keyCode = $event.keyCode ? $event.keyCode : $event.which;
    if (keyCode < 48 || keyCode > 57) {
      $event.preventDefault();
    }

    var ownermobileInput = document.getElementById("ownermobileInput");
    if (
      (ownermobileInput.value == "" || ownermobileInput.length > 1) &&
      (keyCode == 48 ||
        keyCode == 49 ||
        keyCode == 50 ||
        keyCode == 51 ||
        keyCode == 52 ||
        keyCode == 53)
    ) {
      $event.preventDefault();
    }
  };

  const checkEmpty = (field) => field != null && field !== "";

  const startMobileTimer = () => {
    timerState.timerMobileStatus = true;
    if (timerState.timerMobileCount > 0) {
      setTimeout(() => {
        timerState.timerMobileCount--;
        startMobileTimer();
      }, 1000);
      const minutes = Math.floor(timerState.timerMobileCount / 60);
      let seconds = timerState.timerMobileCount % 60;
      if (seconds < 10) {
        timerState.timerMobileInterval = `0${minutes}:0${seconds}`;
      } else {
        timerState.timerMobileInterval = `0${minutes}:${seconds}`;
      }
      timerState.resendOtpBtnStatus = false;
    } else {
      timerState.timerMobileCount = 120;
      timerState.timerMobileStatus = false;
      timerState.resendOtpBtnStatus = true;
    }
  };

  const validateAddGstNumber = (e) => {
    var regexGst = /[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    let add_gst_number = e.target.value.toUpperCase();
    if (add_gst_number && !add_gst_number.match(regexGst)) {
      let gstErrMsg = "Please enter valid GST Number";
      let errStatus = true;
      let pannumber = null;
      return { gstErrMsg, errStatus, pannumber };
    } else {
      let gstErrMsg = "";
      let errStatus = false;
      let pannumber = add_gst_number.substr(2, 10);
      return { gstErrMsg, errStatus, pannumber };
    }
  };

  const validateAddPanCardNumber = (e) => {
    var regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
    let add_pan_number = e.target.value.toUpperCase();
    if (add_pan_number && !add_pan_number.match(regex)) {
      let panErrMsg = "Please enter valid PAN Number";
      let errStatus = true;
      return { panErrMsg, errStatus };
    } else {
      let panErrMsg = "";
      let errStatus = false;
      return { panErrMsg, errStatus };
    }
  };

  const encrypt = (text) => {
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
  };

  const encrypteData = (data) => {
    if (data) {
      const key = CryptoJS.PBKDF2(ENCRYPT_KEY, "salt", {
        keySize: 256 / 32,
        iterations: 100,
      });
      const iv = CryptoJS.enc.Utf8.parse(ENCRYPT_IV);
      const encrypted = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
    }
  };

  const decrypt = (data) => {
    return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
  };

  const decrypteData = (data) => {
    if (data) {
      const key = CryptoJS.PBKDF2(ENCRYPT_KEY, "salt", {
        keySize: 256 / 32,
        iterations: 100,
      });
      const iv = CryptoJS.enc.Utf8.parse(ENCRYPT_IV);
      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: CryptoJS.enc.Hex.parse(data) },
        key,
        { iv: iv, mode: CryptoJS.mode.CBC }
      );
      return decrypted.toString(CryptoJS.enc.Utf8);
    }
  };

  const isLetterWithMultipleSpace = (e) => {
    let charspace = String.fromCharCode(e.keyCode);
    if (/^[A-Za-z\s]+$/.test(charspace)) return true;
    else e.preventDefault();
  };

  const maskedNumber = (getvalue) => {
    const maskedDigits = "X".repeat(getvalue.length - 6);
    const FirstThreeDigits = getvalue.slice(0, 3);
    const lastThreeDigits = getvalue.slice(-3);
    return FirstThreeDigits + maskedDigits + lastThreeDigits;
  };

  const maskedEmail = (getvalue) => {
    const [name, domain] = getvalue.split("@");
    return `${name[0]}${new Array(name.length).join("*")}@${domain}`;
  };

  const maskedVoterID = (id) => {
    if (!id || typeof id !== "string") return "N/A";
    const visiblePrefix = id.slice(0, 3); 
    const visibleSuffix = id.slice(-2);  
    const maskedLength = id.length - visiblePrefix.length - visibleSuffix.length;
    if (maskedLength <= 0) return id; 
    return visiblePrefix + "*".repeat(maskedLength) + visibleSuffix;
  };

  const maskedPanCard = (pan) => {
    if (!pan || typeof pan !== "string" || pan.length !== 10) return "Invalid PAN";
    const firstThree = pan.slice(0, 3);      
    const lastOne = pan.slice(-1); 
    const maskedMiddle = "*".repeat(6);      
    return firstThree + maskedMiddle + lastOne;
  };

  const maskedDrivingLicence = (licence) => {
    if (!licence || typeof licence !== "string" || licence.length < 10) return "Invalid Licence";
    const visibleStart = licence.slice(0, 4);
    const visibleEnd = licence.slice(-3);
    const maskedMiddle = "*".repeat(licence.length - 7); 

    return visibleStart + maskedMiddle + visibleEnd;
  };

  const maskedPassportNumber = (passport) => {
    if (!passport || typeof passport !== "string" || passport.length !== 8) return "Invalid Passport";
    const visibleStart = passport.slice(0, 1);
    const visibleEnd = passport.slice(-2);
    const maskedMiddle = "*".repeat(5); 

    return visibleStart + maskedMiddle + visibleEnd;
  };

  const maskedAddressDetails = (address) => {
    if (!address || typeof address !== "string") return "N/A";
    const parts = address.split(",").map(part => part.trim());
    const maskedParts = parts.map((part, index) => {
      if (index === parts.length - 1 && /^\d{6}$/.test(part)) {
        return part.slice(0, 3) + "***";
      }
      if (part.length > 3) {
        return part[0] + "*".repeat(part.length - 1);
      }

      return "*".repeat(part.length);
    });
    return maskedParts.join(", ");
  };


  const firstCapitalize = (e) => {
    const str = e;
    const arr = str.split(" ");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    const str2 = arr.join(" ");
    return str2;
  };

  function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  const replacebrake = (html) => {
    const doc = html;
    return doc.replace(/(\r)*\n/g, "<br>");
  };

  const format_timestamp = ( value ) => {
    if ( value ) {
      var localTime = new Date( value * 1000 ).toUTCString();
      return moment( localTime ).format( "DD/MM/YYYY @ hh:mm a" );
    } else {
      return 'N/A';
    }
  }

  return {
    onlyNumber,
    onlyNumbers,
    isLetterWithSpace,
    isLetterWithOutSpace,
    mobileSearchFormat,
    onlymobileEditFormat,
    checkEmpty,
    startMobileTimer,
    timerState,
    validateAddGstNumber,
    validateAddPanCardNumber,
    encrypt,
    decrypt,
    isLetterWithMultipleSpace,
    maskedNumber,
    maskedEmail,
    encrypteData,
    decrypteData,
    onPasteMobile,
    onPasteJobMobile,
    onlyNumberMobile,
    firstCapitalize,
    isObjectEmpty,
    replacebrake,
    isAlphaNumeric,
    onPasteAadhar,
    format_timestamp,
    maskedVoterID,
    maskedPanCard,
    maskedDrivingLicence,
    maskedPassportNumber,
    maskedAddressDetails,
  };
}
